import { useEffect, useState } from "react";
import RealtimeAPIChatbox from "../../Components/AIAgent/RealtimeAPIChatbox";
import { getOrganization } from "../../API/Organization/organization";
import { useParams, useSearchParams } from "react-router-dom";
import Loader from "../../Components/Shared/Loader/loader";
import { getEntities } from "../../API/Entity/Entity";
import { getProjectByInstanceId } from "../../API/Project/project";
import { Switch } from "@progress/kendo-react-inputs";
import AIChatBox from "../../Components/AIAgent/Chatbox";

function CopilotChatPage() {

    const params = useParams();

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [organization, setOrganization] = useState(null);
    const [entities, setEntities] = useState([]);
    const [pageId, setPageId] = useState(null);
    const [projectId, setProjectId] = useState(null);
    const [entityId, setEntityId] = useState(null);
    const [searchParams] = useSearchParams();
    const [useAssistant, setUseAssistant] = useState(true);

    useEffect(() => {
        getData()
            .catch((err) => {
                console.log(err);
                setError(err);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    async function getData() {
        debugger;
        const instanceId = params.projectId;
        const project = await getProjectByInstanceId(instanceId);
        const [orgResponse, entitiesResponse] = await Promise.allSettled([
            getOrganization(params.organizationId),
            getEntities(project._id)
        ]);
        setProjectId(project._id);
        if (orgResponse && orgResponse.status === "fulfilled") {
            setOrganization(orgResponse.value);
        }
        if (entitiesResponse && entitiesResponse.status === "fulfilled") {
            setEntities(entitiesResponse.value);
            const entitySysName = searchParams.get('entitySysName');
            const entityId = entitiesResponse.value.find(entity => entity.sysName === entitySysName)?._id;
            setEntityId(entityId);
        }
    }

    if (loading) {
        return (
            <Loader />
        )
    }

    if (error) {
        return (
            <div>
                <h1>Error</h1>
                <p>{error.message}</p>
                <pre>
                    {error.stack}
                </pre>
            </div>
        )
    }

    return (
        <div className="h-100 w-100 p-2 d-flex flex-column">
            <AIChatBox
                instanceId={params.projectId}
                organizationId={params.organizationId}
                projectId={projectId}
                subscriptionId={organization?.subscriptionId}
                entities={entities}
                entityId={entityId}
                pageSysName={searchParams.get('pageSysName')}
            />
        </div>
    )
}

export default CopilotChatPage; 